import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getSelectMissingWord = (params) => {
	var url = ApiRouters.SELECTMISSINGWORD;
	return api.get(url, { params });
};

export const getSelectMissingWordDetail = (id, params) => {
	var url = `${ApiRouters.SELECTMISSINGWORD}/${id}`;
	return api.get(url, { params });
};

export const createQuesSelectMissingWord = (body) => {
	var url = ApiRouters.SELECTMISSINGWORD;
	return api.post(url, body);
};

export const updateSelectMissingWordDetail = (body) => {
	var url = `${ApiRouters.SELECTMISSINGWORD}/${body.get('id')}`;
	return api.put(url, body);
};

export const deleteSelectMissingWord = (id) => {
	var url = `${ApiRouters.SELECTMISSINGWORD}/${id}`;
	return api.delete(url);
};
